/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_SubtitleInputs */

const vi_cashflow_subtitle = /** @type {(inputs: Cashflow_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền vào (thanh toán) − tiền ra (chi) = net, tách tiền mặt và ngân hàng`)
};

/**

* @param {Cashflow_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_subtitle = /** @type {((inputs?: Cashflow_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_subtitle(inputs)
});